<template>
  <div v-loading.fullscreen="loading">
    <el-table :data="questions" class="table" border height="calc(100vh - 263px)">
      <el-table-column type="expand">
        <template #default="scope">
          <div>
            <div class="desc-item">
              <span class="field-title">Taklif turi:</span>
              <span v-html="types[scope.row.type]"></span>
            </div>
            <div class="desc-item">
              <span class="field-title">Murojaat matni:</span>
              <span v-html="scope.row.text"></span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="lang" label="Til" width="120"/>
      <el-table-column prop="text" label="Murojaat matni" min-width="200">
        <template #default="scope">
          <div class="initiative-title" v-html="scope.row.text"></div>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="Taklif turi" min-width="150">
        <template #default="scope">
          <div class="initiative-title" v-html="types[scope.row.type]"></div>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24">
        <div class="pagination-wrapper">
          <span v-if="totalElements">Jami: {{ totalElements }}</span>
          <el-pagination
              v-model:current-page="currentPage"
              class="pagination"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              layout="sizes, prev, pager, next"
              :total="totalElements"
              v-model:page-size="size"
              :page-count="totalPages"
              :background="true"
              :page-sizes="[15,20,30,50,100,200, 500, 1000]"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {ElNotification} from "element-plus";

export default {
  name: "SuggestionList",
  computed: {
    currentPage() {
      return this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1;
    },
  },
  data() {
    return {
      loading: false,
      types: {
        VOTE: 'Ovoz berish mexanizmini takomillashtirish',
        WINNER: "G'oliblarni aniqlash mexanizmini takomillashtirishs",
        TOTAL_FUND: 'Loyihalarni maksimal qiymatini belgilash bo\'yicha',
        TECH: 'Portal texnik imkoniyatlarini kengaytirish',
        FORUM_TYPE: 'Portal texnik imkoniyatlarini kengaytirish',
        FUND_AND_REALIZATION: "Loyihalarni moliyalashtirish va amalga oshirish bo'yicha",
        DATE: "Jarayonlarni o'tkazish muddati bo'yicha",
        OTHER: 'Boshqa masalalar',
      },
      questions: [],

      totalElements: 0,
      totalPages: null,
      size: 20,
      page: 1,
    }
  },
  methods: {
    handleSizeChange(val) {
      this.page = 1;
      this.$router
          .replace({
            query: {...this.$route.query, size: val},
          }).then(() => {
        this.getSuggestions();
      }).catch(() => {
      });
    },
    handleCurrentChange(val) {
      this.$router
          .replace({
            query: {...this.$route.query, page: val},
          }).then(() => {
        this.getSuggestions();
      }).catch(() => {
      });
    },
    getSuggestions() {
      this.loading = true;
      this.page = this.$route.query.page ? this.$route.query.page : 1;
      this.size = this.$route.query.size ? parseInt(this.$route.query.size || "") : 20;
      this.$http.get(`api/v2/info/suggestions`, {
        params: {
          page: this.page - 1,
          size: this.size
        }
      }).then(({data}) => {
        this.questions = data.content
        this.totalElements = data.totalElements;
        this.totalPages = data.totalPages;
        this.size = data.size;
      }).catch((err) => {
        console.log(err)
        ElNotification.error({message: "Ma'lumot yuklashda xatolik sodir bo'ldi. Iltimos, qayta yuklang ko'ring."})
      }).finally(() => {
        this.loading = false
      })
    },
  },

  mounted() {
    if (this.$route.query.status) {
      this.selectedStatus = this.$route.query.status
    }
    this.$nextTick(() => {
      this.getSuggestions();
    })
  }

}
</script>

<style scoped>

.initiative-title, :deep(.el-dialog__header) {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.desc-item {
  margin: 10px;
}

.field-title {
  color: #0F152D;
  font-weight: bold;
  margin-right: 5px;
}

:deep(.el-table .el-table__cell) {
  z-index: unset !important;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
  margin-bottom: 3px;
  height: 40px;
}

.pagination-wrapper > span {
  color: #0A194E;
  font-family: "Montserrat-Bold", sans-serif;
}
</style>